class PriceCompositionUtils {
  static isCost(label: string) {
    return label.toLowerCase().includes('custo');
  }

  static isRoyalties(label: string) {
    return label.toLowerCase().includes('royalties');
  }

  static formatLabel(label: string) {
    if (PriceCompositionUtils.isCost(label)) {
      return 'custo';
    }
    if (PriceCompositionUtils.isRoyalties(label)) {
      return 'royalties';
    }

    return label;
  }
}

export default PriceCompositionUtils;
